import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Page from "./../components/Page";
import Section from "./../components/Section";
import NameCard from "./../components/NameCard";
import WithSideNav from "../components/WithSideNav";
import SEO from "../components/SEO";

function TeamPage() {
  const sideNavProps = [
    {
      title: "About Us",
      link: "/about"
    },
    {
      title: "Team & Collaborators",
      link: "/team"
    },
    {
      title: "Support & Collaborate",
      link: "/get-support"
    },
    {
      title: "Funding History",
      link: "/history"
    }
  ];

  return (
    <Page>
      <SEO title="Team | OHIF" />
      <Section>
        <WithSideNav sideNavProps={sideNavProps} title="Team">
          <h2 className="text-blue-100 text-3xl">Founding Members</h2>
          <div className="flex flex-row flex-wrap justify-start text-left">
            <NameCard
              name="Gordon J. Harris, Ph.D"
              email="harris@helix.mgh.harvard.edu"
              title="Principal Investigator & Director"
              affiliations={["Massachusetts General Hospital", "Yunu"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Gordon J. Harris, Ph.D"
                className="rounded-full namecard-image"
                src="../images/team-gordon-harris.png"
              />
            </NameCard>

            <NameCard
              name="Erik Ziegler, Ph.D"
              email="erik.ziegler@yunu.io"
              title="Technical Advisor"
              affiliations={["Yunu"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Erik Ziegler, Ph.D"
                className="rounded-full namecard-image"
                src="../images/team-erik-ziegler.png"
              />
            </NameCard>

            <NameCard
              name="Rob Lewis"
              email="rob@radicalimaging.com"
              title="Technical Advisor"
              affiliations={["Radical Imaging"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Rob Lewis"
                className="rounded-full namecard-image"
                src="../images/team-rob-lewis.png"
              />
            </NameCard>

            <NameCard
              name="Chris Hafey"
              email="chafey@gmail.com"
              title="Creator of Cornerstone.js, Technical Advisor"
              affiliations={[]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Chris Hafey"
                className="rounded-full namecard-image"
                src="../images/team-chris-hafey.png"
              />
            </NameCard>
          </div>

          <h2 className="phone-size:h2-heading-ps lg:h2-heading-lg mt-8">
            Team Members
          </h2>

          <div className="flex flex-row flex-wrap justify-start text-left ">
            <NameCard
              name="Joe Boccanfuso"
              email=""
              title="Senior Software Engineer"
              affiliations={["Radical Imaging"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <div className="rounded-full namecard-image bg-[#d9ccbc]" />
            </NameCard>

            <NameCard
              name="James Hanks"
              email="jhanks1@mgh.harvard.edu"
              title="Project Manager"
              affiliations={["Massachusetts General Hospital"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="James Hanks"
                className="rounded-full namecard-image"
                src="../images/team-james-hanks.png"
              />
            </NameCard>

            <NameCard
              name="Hua Li, M.D."
              email="hli11@partners.org"
              title="Developer"
              affiliations={["Massachusetts General Hospital", "Yunu"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Hua Li, M.D."
                className="rounded-full namecard-image"
                src="../images/team-hua-li.png"
              />
            </NameCard>

            <NameCard
              name="Steve Pieper, Ph.D"
              email=""
              title="Advisor"
              affiliations={["Isomics"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Steve Pieper, Ph.D"
                className="rounded-full namecard-image"
                src="../images/team-steve-pieper.png"
              />
            </NameCard>

            <NameCard
              name="Dan Rukas"
              email="drukas@mgh.harvard.edu"
              title="UX Design"
              affiliations={["Massachusetts General Hospital"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Dan Rukas"
                className="rounded-full namecard-image"
                src="../images/team-dan-rukas.png"
              />
            </NameCard>

            <NameCard
              name="Alireza Sedghi, Ph.D"
              email="alireza.sedghi@yunu.io"
              title="Senior Software Engineer"
              affiliations={["Yunu"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Alireza Sedghi, Ph.D"
                className="rounded-full namecard-image"
                src="../images/team-alireza-sedghi.png"
              />
            </NameCard>

            <NameCard
              name="Supriya Somarouthu, M.D."
              email=""
              title="Subject Matter Expert"
              affiliations={["Yunu"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Supriya Somarouthu, M.D."
                className="rounded-full namecard-image"
                src="../images/team-supriya-somarouthu.png"
              />
            </NameCard>

            <NameCard
              name="Bill Wallace"
              email=""
              title={<>Lead Architect &amp;<br />Imaging Specialist</>}
              affiliations={["Radical Imaging"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <StaticImage
                alt="Bill Wallace"
                className="rounded-full namecard-image bg-[#d9ccbc]"
                src="../images/team-bill-wallace.png"
              />
            </NameCard>

            <NameCard
              name="Hong Xiao"
              email=""
              title="Quality Assurance"
              affiliations={["Radical Imaging"]}
              className="w-full sm:w-1/2 lg:w-1/3 mb-8"
            >
              <div className="rounded-full namecard-image bg-[#d9ccbc]" />
            </NameCard>
          </div>
        </WithSideNav>
      </Section>
    </Page>
  );
}

export default TeamPage;
